<template>
    <div id="app">
        <HeaderSection />
        <main>
            <HeroSection />
            <FeaturesSection />
            <HowItWorksSection />
            <IntegrationsSection />
            <PricingSection />
            <CtaSection />
            <ContactSection />
        </main>
        <FooterSection />

        <PrivacyPolicyModal :is-open="privacyModalOpen" @close="privacyModalOpen = false" />
        <TermsOfServiceModal :is-open="termsModalOpen" @close="termsModalOpen = false" />
    </div>
</template>

<script lang="ts">
import { defineComponent, ref, provide } from 'vue';
import { useSeoHead } from './composables/useSeoHead';

import HeaderSection from './components/organisms/Header.vue';
import HeroSection from './components/organisms/HeroSection.vue';
import FeaturesSection from './components/organisms/FeaturesSection.vue';
import HowItWorksSection from './components/organisms/HowItWorksSection.vue';
import IntegrationsSection from './components/organisms/IntegrationsSection.vue';
import PricingSection from './components/organisms/PricingSection.vue';
import CtaSection from './components/organisms/CtaSection.vue';
import ContactSection from './components/organisms/ContactSection.vue';
import FooterSection from './components/organisms/Footer.vue';
import PrivacyPolicyModal from './components/organisms/PrivacyPolicyModal.vue';
import TermsOfServiceModal from './components/organisms/TermsOfServiceModal.vue';

export default defineComponent({
    name: 'HomePage',
    components: {
        HeaderSection,
        HeroSection,
        FeaturesSection,
        HowItWorksSection,
        IntegrationsSection,
        PricingSection,
        CtaSection,
        ContactSection,
        FooterSection,
        PrivacyPolicyModal,
        TermsOfServiceModal
    },
    setup() {
        // Setup SEO head tags
        useSeoHead();

        // Modal state
        const privacyModalOpen = ref(false);
        const termsModalOpen = ref(false);

        // Modal control functions
        const openPrivacyModal = () => {
            privacyModalOpen.value = true;
        };

        const openTermsModal = () => {
            termsModalOpen.value = true;
        };

        // Provide modal controls to child components
        provide('legalModals', {
            openPrivacyModal,
            openTermsModal
        });

        return {
            privacyModalOpen,
            termsModalOpen
        };
    }
});
</script>

<style>
/* Global styles are in main.css */
</style>
